module.exports = __webpack_public_path__ + "img/visit_img.ea5b2e30.png";